import callRequestLahi from './call-request-lahi.vue';
import Vue from 'vue';
import { mediaQueries } from '../../../common/media-query/media-query';
import { setPayload } from '../../../common/call-request-api/call-request-api';
import i18n from '../../../common/i18n/i18n';
window.addEventListener('call-request-init', ()=>{
	if (!window.customElements.get('call-request-component-lahi')) {
		Vue.customElement('call-request-component-lahi', callRequestLahi, {
			beforeCreateVueInstance(RootComponentDefinition) {
				RootComponentDefinition.mediaQueries = mediaQueries;
				RootComponentDefinition.i18n = i18n;
				return RootComponentDefinition;
			},
			destroyTimeout: 100
		});
		const event = new CustomEvent('call-request-lahi-ready');
		window.dispatchEvent(event);
	}
});
window.addEventListener('call-request-lahi-set-payload', setPayload);
